import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Clock, ArrowRight } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { useLang } from "@/lib/i18n";
import { useAuth } from "@/lib/auth";

function ResultLayout({ icon: Icon, iconClass, title, body, ctaLabel, ctaTo, testid }) {
  return (
    <div>
      <Header />
      <section className="max-w-lg mx-auto px-6 py-24 text-center" data-testid={testid}>
        <div className={`w-16 h-16 mx-auto rounded-full flex items-center justify-center ${iconClass}`}>
          <Icon className="w-8 h-8" />
        </div>
        <h1 className="font-display text-4xl text-white/95 mt-6">{title}</h1>
        <p className="text-white/60 mt-4">{body}</p>
        <Link to={ctaTo} className="lp-btn-primary mt-8 inline-flex">
          {ctaLabel} <ArrowRight className="w-4 h-4" />
        </Link>
      </section>
      <Footer />
    </div>
  );
}

export function PaymentSuccessPage() {
  const { t } = useLang();
  const { refresh } = useAuth();
  React.useEffect(() => { refresh(); }, [refresh]);
  return (
    <ResultLayout
      icon={CheckCircle2}
      iconClass="bg-emerald-500/10 border border-emerald-400/30 text-emerald-400"
      title={t("payment.success.title")}
      body={t("payment.success.body")}
      ctaLabel={t("payment.success.cta")}
      ctaTo="/dashboard"
      testid="payment-success"
    />
  );
}

export function PaymentCancelPage() {
  const { t } = useLang();
  return (
    <ResultLayout
      icon={XCircle}
      iconClass="bg-red-500/10 border border-red-400/30 text-red-400"
      title={t("payment.cancel.title")}
      body={t("payment.cancel.body")}
      ctaLabel={t("payment.cancel.cta")}
      ctaTo="/dashboard"
      testid="payment-cancel"
    />
  );
}

export function PaymentPendingPage() {
  const { t } = useLang();
  return (
    <ResultLayout
      icon={Clock}
      iconClass="bg-amber-500/10 border border-amber-400/30 text-amber-400"
      title={t("payment.pending.title")}
      body={t("payment.pending.body")}
      ctaLabel={t("payment.pending.cta")}
      ctaTo="/dashboard"
      testid="payment-pending"
    />
  );
}
